import React from 'react'
import { useRouter } from 'next/router'

import { useStory } from '@hooks/book/useStory'
import { useAuthentication } from '@hooks/useAuthentication'
import { useAlert } from '@hooks/useAlert'
import { StoryDetailPageProps } from './interface'

export function withStoryDetailPage(Component: React.FC<StoryDetailPageProps>) {
  function WithStoryDetailPage() {
    const alert = useAlert()
    const router = useRouter()
    const { data, isLoading } = useStory()
    const {
      user: { id },
    } = useAuthentication()

    if (!!data && id !== data?.penName.user.id) {
      alert.error('ขออภัย คุณไม่ใช่เจ้าของเรื่องนี้')
      setTimeout(() => {
        router.push('/my-writing')
      }, 500)
      return null
    }

    const pageProps = {
      isLoading,
    }
    return <Component {...pageProps} />
  }

  return WithStoryDetailPage
}
